import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '@/lib/api';
import { ZitaLogo, ZitaWordmark } from '@/components/ZitaLogo';
import { PublicFooter } from '@/components/PublicFooter';
import { AUTH } from '@/constants/testIds';

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const [state, setState] = useState('verifying');
  useEffect(() => {
    const token = params.get('token');
    if (!token) { setState('bad'); return; }
    api.post('/auth/verify-email', { token })
      .then(() => setState('done'))
      .catch(() => setState('bad'));
  }, [params]);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-10">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <ZitaLogo size={44} />
          <ZitaWordmark className="text-3xl" />
        </Link>
        <div className="zita-card p-8 w-full max-w-md text-center" data-testid={AUTH.verifySubmit}>
          {state === 'verifying' && <div className="text-zita-mocha">Verifying…</div>}
          {state === 'done' && (
            <>
              <h1 className="font-serif text-3xl text-zita-espresso">Email verified</h1>
              <p className="mt-2 text-sm text-zita-mocha">
                Your account is confirmed. Next: choose a plan and start your 7-day free trial.
              </p>
              <Link to="/billing" className="zita-btn-primary inline-block mt-6">
                Choose plan &amp; start trial
              </Link>
            </>
          )}
          {state === 'bad' && (
            <>
              <h1 className="font-serif text-3xl text-zita-espresso">Invalid link</h1>
              <p className="mt-2 text-sm text-zita-mocha">This verification link is invalid or expired.</p>
            </>
          )}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
};

export default VerifyEmail;
